/* eslint-disable class-methods-use-this */
import { env } from '@/common';

const noop = () => {};
const LXAnalytics = (window as any).LXAnalytics || noop;

class Analytics {
  constructor() {
    LXAnalytics('config', 'onWebviewAppearAutoPV', false);
  }

  lxCommonParams() {
    // lx 通用字段，需要业务自己处理
    return {
      scorePlanId: env.coreBusinessParams.scorePlanId || '-999',
      tradeNo: env.inpayBasicBusinessParams.tradeno || '-999',
      entry: env.entry || '-999',
      pageinfo: env.openType.toString() || '-999',
      process_type: env.reversionId - 1,
      utm_source: env.utmSource || '-999',
      page_style: env.payDeferStyleType || '-999',
      credit_type: env.creditType || '-999',
      // 临时参数区分新旧版本
      page_version: 'new',
    };
  }

  pv(cid: string, params = {} as any) {
    const valLab = {
      ...this.lxCommonParams(),
      ...params,
    };
    const environment = {};
    LXAnalytics(
      'pageView',
      {
        custom: valLab,
      },
      environment,
      cid
    );
  }

  mc(bid: string, params = {} as any, opt?: {}) {
    const options = {
      ...this.lxCommonParams(),
      ...opt,
    };
    const valLab = {
      ...this.lxCommonParams(),
      ...params,
      technology_log_version: '5.5.5', // 版本号 1.0.0 无法上报 mis, 必须大于 3.1.0 才可以上报,5.5.5 只是一个辨识度强的版本号
      priority: 'normal',
    };
    LXAnalytics('moduleClick', bid, valLab, options);
  }

  mv(bid: string, params = {} as any, opt?: {}) {
    const options = {
      ...this.lxCommonParams(),
      ...opt,
    };
    const valLab = {
      ...options,
      ...params,
    };
    LXAnalytics('moduleView', bid, valLab, options);
  }

  addTag(cids: string, CommonParams: any, tagObj: any) {
    const options = {
      [cids]: {
        ...this.lxCommonParams(),
        ...CommonParams,
        ...tagObj,
      },
    };
    LXAnalytics('tag', 'pay', options);
  }
}

const lx = new Analytics();

export { lx };
